import { VersionedTransaction } from "@solana/web3.js";

const SIGNATURE_LENGTH_BYTES = 64;
const V0_MESSAGE_PREFIX = 0x80;
const MAX_ZERO_PADDING_BEFORE_MESSAGE_BYTES = 16;

export function deserializeVersionedTransactionWireBytes(bytes) {
  try {
    return VersionedTransaction.deserialize(bytes);
  } catch (error) {
    const repaired = stripZeroPaddingBeforeV0Message(bytes);
    if (!repaired) throw error;
    return VersionedTransaction.deserialize(repaired);
  }
}

export function normalizeVersionedTransactionWireBytes(bytes) {
  return deserializeVersionedTransactionWireBytes(bytes).serialize();
}

export function base64ToBytes(value) {
  const binary = atob(String(value || ""));
  return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

export function stripZeroPaddingBeforeV0Message(bytes) {
  const decodedSignatureCount = readShortU16(bytes, 0);
  if (!decodedSignatureCount) return null;

  const messageOffset = decodedSignatureCount.offset + decodedSignatureCount.value * SIGNATURE_LENGTH_BYTES;
  if (messageOffset >= bytes.length || bytes[messageOffset] === V0_MESSAGE_PREFIX) {
    return null;
  }

  let paddedMessageOffset = messageOffset;
  while (
    paddedMessageOffset < bytes.length &&
    bytes[paddedMessageOffset] === 0 &&
    paddedMessageOffset - messageOffset < MAX_ZERO_PADDING_BEFORE_MESSAGE_BYTES
  ) {
    paddedMessageOffset += 1;
  }

  if (
    paddedMessageOffset === messageOffset ||
    paddedMessageOffset >= bytes.length ||
    bytes[paddedMessageOffset] !== V0_MESSAGE_PREFIX
  ) {
    return null;
  }

  const repaired = new Uint8Array(bytes.length - (paddedMessageOffset - messageOffset));
  repaired.set(bytes.subarray(0, messageOffset), 0);
  repaired.set(bytes.subarray(paddedMessageOffset), messageOffset);
  return repaired;
}

function readShortU16(bytes, offset) {
  let value = 0;
  for (let index = 0; index < 3; index += 1) {
    const cursor = offset + index;
    if (cursor >= bytes.length) return null;
    const byte = bytes[cursor];
    value |= (byte & 0x7f) << (index * 7);
    if ((byte & 0x80) === 0) {
      return { value, offset: cursor + 1 };
    }
  }
  return null;
}
